module.exports = __webpack_public_path__ + "img/up-cadou-craciun.ac0bd1fd.png";